import clsx from "clsx";
import type { ReactNode } from "react";
import "./TableTotals.scss";

export type TableTotalItem = {
  label: string;
  value: ReactNode;
  tone?: "default" | "primary" | "positive" | "negative";
};

// Dải số tổng đặt trên đầu bảng (khe `tabs` của TableLayout) để luôn nhìn thấy khi bảng dài
export const TableTotals = ({ items, note }: { items: TableTotalItem[]; note?: ReactNode }) => (
  <div className="tableTotals">
    {items.map((item) => (
      <div key={item.label} className="tableTotals__item">
        <span className="tableTotals__label">{item.label}</span>
        <span className={clsx("tableTotals__value", item.tone && `is-${item.tone}`)}>{item.value}</span>
      </div>
    ))}
    {note ? <span className="tableTotals__note">{note}</span> : null}
  </div>
);
